import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import React from 'react';

interface ProfileIconProps {
  color?: string;
  style?: React.CSSProperties;
}

export const ProfileIcon = ({ color = RoutalPalette.primary40, style = {}, ...props }: ProfileIconProps) => {
  const { width = `20px`, height = `20px` } = style;
  return (
    <SvgIcon {...props} viewBox="0 0 21 20" style={{ width, height, ...style }}>
      <g>
        <rect x="0.169922" width={width} height={height} rx="4" fill={color} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.36812 13.5216C7.36785 13.5152 7.36771 13.5089 7.36771 13.5025C7.36771 12.5844 8.65829 11.5246 10.1699 11.5246C11.6206 11.5246 12.8556 12.6285 12.9643 13.5274C14.0035 12.7031 14.6699 11.4294 14.6699 10C14.6699 7.51472 12.6552 5.5 10.1699 5.5C7.68464 5.5 5.66992 7.51472 5.66992 10C5.66992 11.426 6.33322 12.6971 7.36812 13.5216ZM15.1699 10C15.1699 12.7614 12.9313 15 10.1699 15C7.4085 15 5.16992 12.7614 5.16992 10C5.16992 7.23858 7.4085 5 10.1699 5C12.9313 5 15.1699 7.23858 15.1699 10ZM12.0241 9.31512C12.0241 8.32391 11.1991 7.52937 10.1699 7.52937C9.14072 7.52937 8.31573 8.32391 8.31573 9.31512C8.31573 10.3063 9.14072 11.1009 10.1699 11.1009C11.1991 11.1009 12.0241 10.3063 12.0241 9.31512Z"
          fill={RoutalPalette.white}
        />
      </g>
    </SvgIcon>
  );
};
